import { isMonday, startOfWeek } from "date-fns";

/**
 * get previous or current monday and friday dates in YYYY-MM-DD format
 * @param offset number week offset instance -1 is starting a week ago from today
 * @returns string[] with 0 index == monday and 1 index == friday
 */
export const getMondayFridayDates = (offset = 0, startDate = new Date()) => {
  const dates = [];

  // Create a new date instance for offset calculation
  const baseDate = new Date(startDate);
  baseDate.setHours(0, 0, 0, 0);
  baseDate.setDate(baseDate.getDate() + offset * 7);

  // Get the previous Monday
  let monday = new Date(baseDate);
  if (!isMonday(monday)) {
    monday = startOfWeek(baseDate, { weekStartsOn: 1 }); // Start week on Monday
  }
  dates.push(monday.toISOString().split("T")[0]);

  // Get the corresponding Friday
  const friday = new Date(monday);
  friday.setDate(monday.getDate() + 4); // Move forward 4 days to get Friday
  dates.push(friday.toISOString().split("T")[0]);

  return dates;
};
